<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-col class="text-left">
              <v-toolbar-title class="textwithbackground--text">
                {{ $t('Список торговых процедур') }}
              </v-toolbar-title>
            </v-col>
          </v-toolbar>
          <v-card-text>
            <lot-list
                :lot-status="lotStatus"
                :privacy-type="privacyType"
                summarizing />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import LotList from '@/components/reused/lot/LotList.vue'
  import { LOT_STATUSES, PRIVACY_TYPES } from '@/constants/business'

  export default {
    components: {
      LotList
    },
    data () {
      return {
        lotStatus: LOT_STATUSES.REGISTERED,
        privacyType: PRIVACY_TYPES.PERSONAL
      }
    }
  }
</script>
